/**
 * GateMobileLayout
 *
 * Mobile rendering shared by the split-screen "gate" screens (public password
 * gate, public share status, app bootstrap error): the standard mobile top bar
 * — clickable brand logo on the left, language/theme controls on the right —
 * with the short content centered below it. Centralizes the logo size, the
 * marketing link, the settings bar and the centered-content choice so all three
 * screens stay in lockstep. Desktop variants use SplitScreenLayout directly.
 *
 * @module components/layout/GateMobileLayout
 */
import type { ReactNode } from 'react';
import { memo } from 'react';

import { BrandLogo } from '@/components/common/BrandLogo';
import { OnboardingSettingsBar } from '@/components/layout/OnboardingSettingsBar';
import { MobilePageLayout } from '@/components/layout/MobilePageLayout';

interface GateMobileLayoutProps {
  children: ReactNode;
}

export const GateMobileLayout = memo(function GateMobileLayout({
  children,
}: GateMobileLayoutProps) {
  return (
    <MobilePageLayout
      logo={<BrandLogo size="sm" linkToHome />}
      actions={<OnboardingSettingsBar />}
      centerContent
    >
      {children}
    </MobilePageLayout>
  );
});
